import { cn } from '@/lib/utils'

interface RealTimeIndicatorProps {
  className?: string
}

/**
 * Pulsing green dot + "Real-time" label. Used in Infrastructure section
 * headers to communicate that data is live and the global date-range
 * selector does not apply.
 */
export function RealTimeIndicator({ className }: RealTimeIndicatorProps) {
  return (
    <div className={cn('inline-flex items-center gap-1.5 text-xs text-muted-foreground', className)}>
      <span className="relative flex h-2 w-2">
        <span className="absolute inline-flex h-full w-full rounded-full bg-status-ok opacity-75 animate-ping" />
        <span className="relative inline-flex h-2 w-2 rounded-full bg-status-ok" />
      </span>
      <span>Real-time</span>
    </div>
  )
}
